import React, { useEffect, useState } from "react";
import { Heading, VStack } from "@chakra-ui/react";
import { AuthenticatedLayout } from "layouts";
import SessionsTable from "./SessionsTable";

const Sessions: React.FC = () => {
  return (
    <AuthenticatedLayout>
      <VStack spacing={8} alignItems="flex-start">
        <Heading as="h1" size="lg">
          Coaching Calls
        </Heading>
        <SessionsTable/>
      </VStack>
    </AuthenticatedLayout>
  );
};

export default Sessions;
